/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetAllTermsFineAmountResponse } from '../models/GetAllTermsFineAmountResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InstallmentFinesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns GetAllTermsFineAmountResponse OK
     * @throws ApiError
     */
    public getAllTermsFineAmount({
        installmentPlanId,
    }: {
        installmentPlanId: string,
    }): CancelablePromise<GetAllTermsFineAmountResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/installments/fines/{installmentPlanId}',
            query: {
                'installmentPlanId': installmentPlanId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
